export const faqsData = {
  es: [
    {
      id: 1,
      question: "¿Cómo calculáis el precio del transporte?",
      answer: "Nuestro sistema calcula el precio basándose en múltiples factores: distancia exacta entre origen y destino, tipo de vehículo (dimensiones y peso), modalidad de transporte (en plataforma o conducido), urgencia del servicio y disponibilidad de transportistas en la ruta. Recibirás un presupuesto detallado y transparente sin costes ocultos."
    },
    {
      id: 7,
      question: "¿Tenéis packs o tarifas para empresas con volumen recurrente?",
      answer: "Sí. Para clientes con volumen recurrente disponemos de packs de transportes y tarifas corporativas a medida con descuentos por volumen, gestor dedicado y prioridad operativa. Trabajamos habitualmente con concesionarios, financieras, aseguradoras y empresas de renting. Escríbenos a hello@autogodelivery.com o por WhatsApp y te preparamos una propuesta personalizada en menos de 24 horas."
    },
    {
      id: 2,
      question: "¿Qué garantías ofrecéis durante el transporte?",
      answer: "Todos nuestros traslados incluyen seguro a todo riesgo que cubre cualquier daño durante el transporte. Realizamos una inspección fotográfica completa antes de la recogida y después de la entrega. Trabajamos exclusivamente con transportistas verificados y con más de 5 años de experiencia. Además, ofrecemos seguimiento GPS en tiempo real."
    },
    {
      id: 3,
      question: "¿Qué cobertura incluye el seguro?",
      answer: "Todos nuestros transportes incluyen un seguro a todo riesgo que cubre cualquier daño que pueda sufrir tu vehículo durante el traslado. La cobertura incluye daños por accidente, robo, vandalismo y fenómenos meteorológicos. Realizamos una inspección fotográfica completa antes de la recogida y después de la entrega para documentar el estado del vehículo."
    },
    {
      id: 4,
      question: "¿Ofrecéis recogida y entrega a domicilio?",
      answer: "Absolutamente. Recogemos tu vehículo en la dirección que nos indiques y lo entregamos donde necesites. No necesitas desplazarte a ningún depósito. Coordinamos horarios flexibles para adaptarnos a tu disponibilidad, tanto para la recogida como para la entrega."
    },
    {
      id: 5,
      question: "¿Trabajáis con empresas y concesionarios?",
      answer: "Sí, ofrecemos soluciones especializadas para empresas, concesionarios y gestoras de flotas. Incluyen: gestión de múltiples vehículos, precios corporativos, facturación mensual, coordinación logística personalizada y un gestor dedicado para tu cuenta. Contacta con nosotros para conocer nuestras tarifas empresariales."
    },
    {
      id: 6,
      question: "¿Cómo puedo hacer seguimiento de mi vehículo?",
      answer: "Una vez iniciado el transporte, recibirás un enlace de seguimiento GPS en tiempo real por email y SMS. Podrás ver la ubicación exacta de tu vehículo en cualquier momento. También te mantendremos informado de cada etapa: confirmación de recogida, inicio del trayecto y confirmación de entrega con fotos."
    }
  ],
  en: [
    {
      id: 1,
      question: "How do you calculate the transport price?",
      answer: "Our system calculates the price based on multiple factors: exact distance between origin and destination, vehicle type (dimensions and weight), transport modality (on platform or driven), service urgency and carrier availability on the route. You will receive a detailed and transparent quote with no hidden costs."
    },
    {
      id: 7,
      question: "Do you offer packs or rates for companies with recurring volume?",
      answer: "Yes. For clients with recurring volume we offer transport packs and tailored corporate rates with volume discounts, a dedicated account manager and operational priority. We regularly work with dealerships, financial firms, insurance companies and renting providers. Reach us at hello@autogodelivery.com or via WhatsApp and we'll prepare a custom proposal within 24 hours."
    },
    {
      id: 2,
      question: "What guarantees do you offer during transport?",
      answer: "All our transfers include comprehensive insurance that covers any damage during transport. We perform a complete photographic inspection before pickup and after delivery. We work exclusively with verified carriers with more than 5 years of experience. Additionally, we offer real-time GPS tracking."
    },
    {
      id: 3,
      question: "What does the insurance cover?",
      answer: "All our transports include comprehensive insurance that covers any damage your vehicle may suffer during the transfer. Coverage includes damage from accidents, theft, vandalism and weather phenomena. We perform a complete photographic inspection before pickup and after delivery to document the vehicle's condition."
    },
    {
      id: 4,
      question: "Do you offer door-to-door pickup and delivery?",
      answer: "Absolutely. We pick up your vehicle at the address you indicate and deliver it wherever you need. You don't need to travel to any depot. We coordinate flexible schedules to adapt to your availability, both for pickup and delivery."
    },
    {
      id: 5,
      question: "Do you work with companies and dealerships?",
      answer: "Yes, we offer specialized solutions for companies, dealerships and fleet managers. They include: management of multiple vehicles, corporate prices, monthly billing, personalized logistics coordination and a dedicated manager for your account. Contact us to learn about our business rates."
    },
    {
      id: 6,
      question: "How can I track my vehicle?",
      answer: "Once the transport has started, you will receive a real-time GPS tracking link by email and SMS. You can see the exact location of your vehicle at any time. We will also keep you informed of each stage: pickup confirmation, journey start and delivery confirmation with photos."
    }
  ]
};

export const faqs = faqsData.es;

export const services = [
  {
    id: 1,
    title: "Recuperación de Coches",
    description: "Servicio especializado de recuperación y traslado de vehículos averiados, accidentados o sin ITV.",
    featured: true
  },
  {
    id: 2,
    title: "Transporte Nacional",
    description: "Traslado rápido y seguro de tu vehículo a cualquier punto de España."
  },
  {
    id: 3,
    title: "Transporte Internacional",
    description: "Llevamos tu vehículo a cualquier país de Europa con total garantía."
  },
  {
    id: 4,
    title: "Transporte de Flotas",
    description: "Soluciones especializadas para empresas con múltiples vehículos."
  }
];

export const stepsData = {
  es: [
    {
      id: 1,
      title: "Solicita presupuesto",
      description: "Rellena el formulario con los detalles de tu transporte y recibe un presupuesto personalizado en minutos."
    },
    {
      id: 2,
      title: "Confirmamos y recogemos",
      description: "Una vez aceptes el presupuesto, coordinamos la recogida de tu vehículo en la ubicación que prefieras."
    },
    {
      id: 3,
      title: "Entregamos tu vehículo",
      description: "Llevamos tu vehículo de forma segura a su destino. Seguimiento en tiempo real incluido."
    }
  ],
  en: [
    {
      id: 1,
      title: "Request quote",
      description: "Fill out the form with your transport details and receive a personalized quote in minutes."
    },
    {
      id: 2,
      title: "We confirm and collect",
      description: "Once you accept the quote, we coordinate the pickup of your vehicle at your preferred location."
    },
    {
      id: 3,
      title: "We deliver your vehicle",
      description: "We safely transport your vehicle to its destination. Real-time tracking included."
    }
  ]
};

export const steps = stepsData.es;